import { render, staticRenderFns } from "./FormEvidencias.vue?vue&type=template&id=2e8fe9f2&scoped=true"
import script from "./FormEvidencias.vue?vue&type=script&lang=js"
export * from "./FormEvidencias.vue?vue&type=script&lang=js"
import style0 from "./FormEvidencias.vue?vue&type=style&index=0&id=2e8fe9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fe9f2",
  null
  
)

export default component.exports